import { useContext, useSyncExternalStore } from "react";

import { MediaContext, MediaStore } from "@/providers/MediaProvider";

export const useMediaStore = (selector: (store: MediaStore) => boolean) => {
  const storeApi = useContext(MediaContext);
  if (!storeApi) throw new Error("useMediaStore() must be used within the MediaContext Provider");
  return useSyncExternalStore(storeApi.subscribe, () => selector(storeApi.getStore()));
};
